import { useState, useEffect, useMemo } from 'react'

const useWindowSize = () => {
    const [windowSize, setWindowSize] = useState({
        width: undefined,
        height: undefined,
    })

    const isMobile = useMemo(() => {
        if (windowSize.width) {
            return windowSize.width < 768
        }
    }, [windowSize])

    useEffect(() => {
        const handleResize = () => {
            if (window) {
                setWindowSize({
                    width: window?.innerWidth,
                    height: window?.innerHeight,
                })
            }
        }
        window?.addEventListener('resize', handleResize)
        handleResize()

        return () => window?.removeEventListener('resize', handleResize)
    }, [])

    return { windowSize, isMobile }
}

export { useWindowSize }
